module.exports = __webpack_public_path__ + "static/media/edMain02.5922e0ea.png";